import fetchRequest from './fetchRequest';
import { logToClientLogger } from "../helpers/clientLogger";
import { getChildByChildGUID } from "rcds-client";
import { servicesClient } from "../services/requestServices";

export const getChildData = async (childId) => {
  const wvRCDS = getRcdsEnvironment();

  try {
    const childrenInfo = await getChildByChildGUID(childId, {
      url: wvRCDS.url,
      apiKey: wvRCDS.apiKey,
      method: "GET",
    });

    if (childrenInfo.success) {
      return childrenInfo.data;
    } else {
      throw new Error(childrenInfo);
    }
  } catch (err) {
    const toClientLogger = {
      response_message: err,
    };
    logToClientLogger(toClientLogger, "error");

    return Promise.reject(err);
  }
};

export async function getProjectData(projectId) {
  const wvRCDS = getRcdsEnvironment();
  const getToken = async (retry = 0) => {
    const result = await servicesClient.getAuth0Token().catch(() => {
      if (retry < 2) {
        return getToken(++retry);
      }

      return { token: "" };
    });

    return result;
  };
  const { token } = await getToken();
  
  const baseUrl = process.env.REACT_APP_RCDS_BASE_URL;
  const apiKey = process.env.REACT_APP_RCDS_API_KEY;


  const requestUrl = `${baseUrl}/api/projects/${projectId}?subscription-key=${apiKey}`;
  const { timeout } = { timeout: 30 * 10000 };
  const requestOpts = {
    method: "GET",
    timeout: timeout,
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiKey,
      "Authorization": `Bearer ${token}`
    },
  };

  // Make RCDS Request
  try {
    const response = await fetchRequest(requestUrl, requestOpts);

    if (!response.ok) {
      const body = response.json();
      const jsonBody = body || {};
      const toClientLogger = {
        response_message: jsonBody.message || "Invalid service response",
        response_body: body || "{}",
        request: requestUrl,
      };
      logToClientLogger(toClientLogger, "error");
      throw new Error("Unable to retreive service data.");
    }

    const respData = response.json();

    return respData;
  } catch (err) {
    return Promise.reject(err);
  }
}

export const listChildrenForSponsor = async (data) => {
  const wvRCDS = getRcdsEnvironment();

  const requestUrl = `${wvRCDS.url}${wvRCDS.endpoints.listChildrenForSponsor}`;
  const { timeout } = { timeout: 30 * 1000 };
  const requestOpts = {
    method: "POST",
    body: JSON.stringify(data),
    timeout: timeout,
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": wvRCDS.apiKey,
    },
  };

  // Make Service Request
  try {
    const response = await fetchRequest(requestUrl, requestOpts);
    const jsonResponse = await response.json();

    // TODO: Clean Up Response Validation And Data Parsing
    if (
      !response.ok ||
      !jsonResponse.success ||
      !jsonResponse.data ||
      !jsonResponse.data.items
    ) {
      const body = jsonResponse;
      const jsonBody = body || {};
      const errorMessage = jsonBody.message || "Invalid service response";

      const responseError = new Error(errorMessage);
      // Reference request object
      responseError.status = response.status;
      // responseError.body = body || "";
      responseError.request = { ...{ url: requestUrl }, ...requestOpts };

      const toClientLogger = {
        response_message: errorMessage || "Invalid service response",
        response_body: jsonResponse || "{}",
        request: requestUrl,
      };
      logToClientLogger(toClientLogger, "error");

      throw responseError;
    }

    return jsonResponse.data.items;
  } catch (err) {
    return Promise.reject(err);
  }
};

// Gets RCDS Env based on current env
export const getRcdsEnvironment = () => {
  const wvRCDSUrl = {
    apiKey:
      window.WVUS_RCDS_VARS &&
      (window.WVUS_RCDS_VARS.apiKey || "989c7856bde14db2ba30b0c492579646"),
    url:
      window.WVUS_RCDS_VARS &&
      (window.WVUS_RCDS_VARS.url || "https://wv-rcds-prd-api.azure-api.net/v3"),
    endpoints: {
      childDetailGet:
        (window.WVUS_RCDS_VARS &&
          window.WVUS_RCDS_VARS.endpoints["child_detail_get"]) ||
        "/api/Sponsorship/children/{identifier}/web",
    },
  };

  return wvRCDSUrl;
};